import { PartnerRefAngebotBeziehungRollen } from '@mng/sales-types';
import { IAntragFragen, IRollenFeatures } from './antrag-fragen';

const baseUvFragenDefs: IAntragFragen = {
  gesundheitsfragenG: new Set(),
  gesundheitsfragenCTFS: false,
  gesundheitsfragen: false,
  geldwaesche: false,
  sensibleDaten: false,
  bezugsrechtErleben: false,
  bezugsrechtAbleben: false,
  bezugsrechtKrankheit: false,
  paragraph_3_1_15: false,
  treuhaenderFrage: false,
  arbeitsStatusFrage: false,
  identifikationsnachweis: false,
  crsRelevant: false,
  fatcaGMSG: false,
  veranlagungBeratung: false,
  schriftformDatennutzung: true,
  bestattung: false,
  familienstand: false,
  geburtsland: false,
  berufsinfo: false,
  sozialVersDaten: false,
  adresse: true,
  nationalitaet: true,
  erhaltbasisInfoBlatt: false
};

export const svRollenFeatures: IRollenFeatures[] = [
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERUNGSNEHMER,
    fragenDefs: { ...baseUvFragenDefs, erhaltbasisInfoBlatt: true }
  },
  {
    rolle: PartnerRefAngebotBeziehungRollen.VERSICHERUNGSNEHMER_2,
    fragenDefs: baseUvFragenDefs
  }
];
